import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextNumberedList = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.16699 8.33364V3.96289C3.60333 4.10092 3.17261 4.48906 2.91699 5.00028M5.83366 15.8336H3.00697V15.417C3.74214 14.902 4.4955 14.4159 5.09802 13.741C5.50048 13.2902 5.54501 12.6154 5.11127 12.1623C4.75898 11.7943 4.14974 11.6737 3.68011 11.8563C3.36301 11.9796 3.18247 12.2267 3.00697 12.5003M17.5003 5.00031H9.16699M17.5003 10.0003H9.16699M17.5003 15.0003H9.16699",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTextNumberedList);
export default ForwardRef;
